import { Icon } from '@chakra-ui/react';

export const CaretLeftIcon = (props: any) => (
  <Icon aria-label="caret left icon" viewBox="0 0 12 12" {...props}>
    <polygon
      transform="translate(8, 2) rotate(90.000000)"
      fill="currentColor"
      points="4 3.01411326 7.00880526 0 8 0.992943369 4 5 0 0.992943369 0.991194745 0"
    />
  </Icon>
);
